import { reject } from "lodash";

const DB_NAME = 'searchDB';
const DB_VERSION = 1;
let DB;

export default {

	async getDb() {
		return new Promise((resolve, reject) => {

			if(DB) { return resolve(DB); }
			let request = window.indexedDB.open(DB_NAME, DB_VERSION);
			
			request.onerror = e => {
				console.log('Error opening db', e);
				reject('Error');
			};
	
			request.onsuccess = e => {
                DB = e.target.result;
				resolve(DB);
			};
			
			request.onupgradeneeded = e => {
                let db = e.target.result;
				db.createObjectStore("datasets", { autoIncrement: true, keyPath:'id' });
				db.createObjectStore("results", { autoIncrement: true, keyPath:'id' });
			};
		});
	},
	async clearCollection(collection) {
		let db = await this.getDb();

		return new Promise(resolve => {
            if(_.includes(db.objectStoreNames,collection)){
                let trans = db.transaction([collection],'readwrite');
                trans.oncomplete = () => {
                    resolve();
                };
                trans.onerror = (err) => {
                    reject(err)
                }
    
                let store = trans.objectStore(collection);
                store.clear();
            }else{
                resolve();
            }
		});	
	},
	async getCollection(collection) {
		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction([collection],'readonly');
			trans.oncomplete = () => {
				resolve(datasets);
            };
            trans.onerror = (err) => {
                reject(err)
            }

			
			let store = trans.objectStore(collection);
			let datasets = [];
			
			store.openCursor().onsuccess = e => {
				let cursor = e.target.result;
				if (cursor) {
					datasets.push(cursor.value)
					cursor.continue();
				}
			};
		});
	},
	async addToCollection(object,collection) {
		let db = await this.getDb();

		return new Promise((resolve,reject) => {

			let trans = db.transaction([collection],'readwrite');
			trans.oncomplete = () => {
				resolve();
            };
            trans.onerror = (err) => {
                reject(err)
            }


			let store = trans.objectStore(collection);
			store.put(object);

		});
	
	}

}